import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TranslateModule} from "@ngx-translate/core";
import {environment} from "../../../../environments/environment";
import {ChatRepository} from "../../../repositories/chat.repository";
import {ActivatedRoute, Router} from "@angular/router";
import {chatMessage} from "../../../models/chatMessage";
import {JsonPipe} from "@angular/common";
import {MessageStatus, MessageType} from "../../../models/enums";

@Component({
  selector: 'app-local-error-message',
  standalone: true,
  imports: [
    TranslateModule,
    JsonPipe
  ],
  templateUrl: './local-error-message.component.html',
  styleUrl: './local-error-message.component.css'
})
export class LocalErrorMessageComponent implements OnInit {
  chatId: string | null = "";
  @Input() message: chatMessage | undefined ;
  @Output() functionCallEvent = new EventEmitter<{ functionName: string, args: any[] }>();
  constructor(private chatRepository: ChatRepository, private router: Router, private route: ActivatedRoute) {}

  async ngOnInit(): Promise<void> {
    this.route.paramMap.subscribe(params => {
      this.chatId = params.get('id');
    });
  }

  reloadPage() {
    window.location.reload();
  }

  async deleteStep() {
    this.chatRepository.deleteTooling(this.chatId, this.message?.messageId).subscribe();
    this.functionCallEvent.emit({functionName: 'loadMessages', args: [this.chatId]});
  }

    protected readonly environment = environment;
  protected readonly MessageType = MessageType;
  protected readonly MessageStatus = MessageStatus;
}
